/* Component in the TalentPage component to display the Callsheet 
   Cast items 
 * Contains the CallCastInfo component to display 
   the extra cast info 
 * Contains the CallCastInfoMob component to display 
   the extra cast info in mobile */
import React, { useState } from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import styles from "../../../styles/Callsheets.module.css";

const CrewCalls2 = (props) => {

  const {
    id,
    day_id,
    name,
    position,
    phone,
    email,
    call,
  } = props;

  // eslint-disable-next-line
  const [crewNew, setCrewNew] = useState({
    id1: id,
    day_id1: day_id,
    name1: name,
    position1: position,
    phone1: phone,
    email1: email,
    call1: call,
  });

  const { name1, 
    position1, 
    call1, } =
    crewNew;

  return (
    <div className={` ${styles.Bold}`}>
    <div className="d-none d-sm-block">
    <Row className='text-center mx-0 mb-0 pb-0' >
    <Col xs={12} className={`${styles.RightPanel} mx-0 px-0`}>
      <Row className={`mt-1 mx-0 d-flex align-items-center`} >
        <Col className={`mx-0 px-0 ${styles.Borderl}`} xs={12} sm={5} >
          <p className={`${styles.BoldScene} my-0 py-0 `}>
          {position1} </p> 
        </Col>
        <Col className={`mx-0 px-0 ${styles.Borderm}`} xs={8} sm={5} >
          <p className={`my-0 py-0 `}>
            {name1} 
          </p>
        </Col>
        <Col className={`mx-0 px-0 text-center ${styles.Border}`} xs={3} sm={2} >
          <p className={`my-0 py-0 `}>{call1}</p>
        </Col>
      </Row>
      <hr className={`mt-1 mb-1 ${styles.BreakCrew}`} />
      </Col>
    </Row>
    </div>
    {/* MOBILE */}
    <div className="d-block d-sm-none">
    <Row className='text-center mx-0 mb-0 pb-0' >
    <Col xs={12} className={`${styles.RightPanel} mx-0 px-0`}>
      <Row className={`mt-1 mx-0 d-flex align-items-center`} >
        <Col className={`mx-0 px-0 ${styles.Borderl}`} xs={8} >
          <p className={`${styles.BoldScene} my-0 py-0`}>
          {position1} </p> 
          <p className={`my-0 py-0 `}>
            {name1} 
          </p>
        </Col>
        <Col className={`mx-0 px-0 text-center ${styles.Border}`} xs={4} >
          <p className={`my-0 py-0 `}>{call1}</p>
        </Col>
      </Row>
      <hr className={`mt-0 mb-0 ${styles.BreakCrew2}`} />
      </Col>
    </Row>
    </div>
    </div>
  );
};

export default CrewCalls2